import axios from "axios";
import {Customer} from "../Types/customer";
import {Site} from "../Types/type";


export const getCustomerFromParent = async (): Promise<Customer[]> => {
  const response = await axios.get<Customer[], any>(`api/customers/all`);

  return response.data;
};

export const getCustomerSites = async (): Promise<Site[]> => {
  const response = await axios.get(`/api/customers/sites`);

  return response.data;
};